export class SearchSettings {
  public dbSearchAsDefaultEnabled = false;
  public isWildCard = false;

  setSearchDefaultMode(value: boolean) {
    this.dbSearchAsDefaultEnabled = value;
  }

  public setDefaultSearchModeByName(name: string) {
    if (name == null || name == '') {
      return;
    }
    name = name.toLowerCase();
    if (name == 'both') {
      this.setSearchDefaultMode(true);
      return;
    }
    this.setSearchDefaultMode(false);
  }
}
